// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"UP-z","inlineTitle":"VP-z","sponsoredAdsWrapper":"WP-z","marketplaceRecosWrapper":"XP-z"};